import React from "react";
import { NavLink } from "react-router-dom";
import { useAuthProvider } from "../customHooks/authContext";
import { Navbar, Nav, Container, Button, Dropdown, NavDropdown } from "react-bootstrap";


function NavigationBar() {


  const { isAuthenticated, role, logout } = useAuthProvider();


  if (!isAuthenticated) return null;

  return (
    <Navbar expand="lg" className="bg-primary bg-gradient shadow-sm">
      <Container >
        <Navbar.Brand className="text-white fw-bold">Gestión de Inscripciones</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {role.includes("Escuela") && (
              <>
                <Nav.Link as={NavLink} to="/members" className="text-light">
                  Miembros
                </Nav.Link>
                <Nav.Link as={NavLink} to="/registration" className="text-light">
                  Inscripciones
                </Nav.Link>
                <Nav.Link as={NavLink} to="/certificates" className="text-light">
                  Certificados
                </Nav.Link>

              </>
            )}

            {role.includes("Administrador") && (
              <>
                {/* Configuración */}
                <Dropdown>
                  <Dropdown.Toggle as={Nav.Link} className="text-light">
                    Configuración
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as={NavLink} to="/events">Eventos</Dropdown.Item>
                    <Dropdown.Item as={NavLink} to="/settings/modalities">Modalidades</Dropdown.Item>
                    <Dropdown.Item as={NavLink} to="/settings/forms">Formas</Dropdown.Item>
                    <Dropdown.Item as={NavLink} to="/users">Usuarios</Dropdown.Item>
                    <Dropdown.Item as={NavLink} to="/schools">Escuelas</Dropdown.Item>

                  </Dropdown.Menu>
                </Dropdown>

              </>
            )}
            {role.includes(["Operador"]) && (
              <>
                {/* Configuración */}
                <Dropdown>
                  <Dropdown.Toggle as={Nav.Link} className="text-light">
                    Configuración
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as={NavLink} to="/events">Eventos</Dropdown.Item>
                    <Dropdown.Item as={NavLink} to="/settings/modalities">Modalidades</Dropdown.Item>
                    <Dropdown.Item as={NavLink} to="/settings/forms">Formas</Dropdown.Item>
                    <Dropdown.Item as={NavLink} to="/users">Usuarios</Dropdown.Item>
                    <Dropdown.Item as={NavLink} to="/schools">Escuelas</Dropdown.Item>

                  </Dropdown.Menu>
                </Dropdown>

              </>
            )}
          </Nav>

          <Button variant="light" onClick={logout} as={NavLink} to="/login">
            Salir
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );

}


export default NavigationBar;
